<div class="wrapper page-center">
	<p class="cavo-logo"><img src="assets/images/cavo_logo_rev.svg" alt="Cavo logo" height="50px" /></p>
	<div class="content">
    <h2>You have been logged out</h2>
    <p>Please use the button below to login to Cavo.</p>

    <button color="primary" mat-flat-button type="button" (click)="signIn()">Login</button>
  </div>
</div>
